<template>
  <div class="content">
    <div id="features">
      <div class="container clearfix">
        <div class="warp">
          <hr class="hr-t">
          <h3 class="title">客人總是在詢問<br>這麼好吃的秘訣是什麼</h3>
          <hr class="hr-t">
        </div>
        <div class="col-12 col-4-t">
          <div class="feature">
            <img src="../assets/feature_1.png" alt="feature_1">
            <p class="secret">台灣本土蔬菜</p>
            <p class="des">In hac habitasse platea dictumst. Vivamus adipiscing fermentum quam volutpat aliquam. Integer et elit eget elit facilisis tristique. Nam vel iaculis mauris.
            </p>
          </div>
        </div>
        <div class="col-12 col-4-t">
          <div class="feature">
            <img src="../assets/feature_2.png" alt="feature_2">
            <p class="secret">專業米其林廚師</p>
            <p class="des">In hac habitasse platea dictumst. Vivamus adipiscing fermentum quam volutpat aliquam. Integer et elit eget elit facilisis tristique. Nam vel iaculis mauris.
            </p>
          </div>
        </div>
        <div class="col-12 col-4-t">
          <div class="feature">
            <img src="../assets/feature_3.png" alt="feature_3">
            <p class="secret">對於專業不能退讓</p>
            <p class="des">In hac habitasse platea dictumst. Vivamus adipiscing fermentum quam volutpat aliquam. Integer et elit eget elit facilisis tristique. Nam vel iaculis mauris.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div id="chef">
      <div class="container clearfix">
        <div class="picture col-12 col-6-t"></div>
        <div class="info col-12 col-6-t">
          <h2 class="name">今日主廚：帕金森、梅在帕</h2>
          <h2 class="nameEnglish">Tody Chef: Plum in Shock</h2>
          <p class="des">Mauris non tempor quam, et lacinia sapien. Mauris accumsan eros eget libero posuere vulputate. Etiam elit elit, elementum sed varius at, adipiscing vitae est. Sed nec felis pellentesque, lacinia dui sed, ultricies sapien. Pellentesque orci lectus, consectetur vel posuere posuere, rutrum eu ipsum. Aliquam eget odio sed ligula iaculis consequat at eget orci. Mauris molestie sit amet metus mattis varius. Donec sit amet ligula eget nisi sodales egestas. Aliquam interdum dolor aliquet dolor sollicitudin fermentum. Donec congue lorem a molestie bibendum.
          </p>
        </div>
      </div>
    </div>
    <div class="comments clearfix">
      <h3 class="title">聽聽別人的感想</h3>
      <div class="container">
        <div class="col-12 col-4-t">
          <div class="comment">
            <div class="col-3">
              <img src="../assets/avatar_1.png" alt="高雄一口吃" class="avater">
            </div>
            <div class="col-9">
              <p class="nickName">高雄一口吃</p>
              <p class="des">自從吃了這家餐廳以後，我口水連續流了一個多月都沒停，下次不要再被我遇到，不然我一定連他們桌子都啃下去。</p>
              <p class="job"> -- 產品經理</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-4-t">
          <div class="comment">
            <div class="col-3">
              <img src="../assets/avatar_2.png" alt="廟口小霸王" class="avater">
            </div>
            <div class="col-9">
              <p class="nickName">廟口小霸王</p>
              <p class="des">自從吃了這家餐廳以後，我口水連續流了一個多月都沒停，下次不要再被我遇到，不然我一定連他們桌子都啃下去。</p>
              <p class="job"> -- 金身道士</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-4-t">
          <div class="comment">
            <div class="col-3">
              <img src="../assets/avatar_3.png" alt="春天也來了" class="avater">
            </div>
            <div class="col-9">
              <p class="nickName">春天也來了</p>
              <p class="des">自從吃了這家餐廳以後，我口水連續流了一個多月都沒停，下次不要再被我遇到，不然我一定連他們桌子都啃下去。</p>
              <p class="job"> -- 美麗萬分</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="preOrder">
      <h3 class="title">我們的位置不太夠坐<br>要不要先定位呢？</h3>
      <div class="container clearfix">
        <div class="map col-12 col-6-t"></div>
        <form class="preOrderForm col-12 col-6-t clearfix">
          <label>姓名<br><input class="input" type="text"></label>
          <label>電話<br><input class="input" type="text"></label>
          <label>信箱<br><input class="input" type="text"></label>
          <label>人數<br><input class="input" type="text"></label>
          <label>是否需要素食</label>
          <label class="vegY">是<input type="radio"></label>
          <label class="vegN">否<input type="radio"></label>
          <div class="btnGroup">
            <button class="cancel">取消</button>
            <button class="submit">送出</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'homePage'
  }
</script>
<style lang="scss" scoped>
  #features {
    padding: 50px 0 60px 0;
    background-color: #EFE9E7;
    img {
      border-radius: 50%;
    }
    .warp {
      text-align: center;
    }
    .title {
      display: inline-block;
    }
    .hr-t {
      display: none;
      width: 15%;
      margin: 31px 0;
      border: 1px solid #979797;
      border-bottom: none;
    }
    .feature {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        margin-top: 30px;
      }
      .secret {
        color: #3D1101;
        margin-top: 20px;
        font-size: 18px;
      }
      .des {
        margin-top: 11px;
        font-size: 16px;
      }
    }
  }
  #chef {
    background: #3D1101;
    .container {
      width: 100%;
    }
    .picture {
      height: 460px;
      background-image: url('../assets/main_chef_brown.png');
      background-position: center;
      background-repeat: no-repeat;
    }
    .info {
      padding: 30px;
    }
    .name, .nameEnglish, .des {
      color: #EFE9E7;
    }
    .name, .nameEnglish {
      font-weight: normal;
    }
    .name {
      margin-top: 30px;
      font-size: 20px;
    }
    .nameEnglish {
      font-size: 16px;
    }
    .des {
      margin-top: 1rem;
    }
  }
  .comments {
    background-color: #EFE9E7;
    padding-top: 50px;
    padding-bottom: 60px;
    .title {
      font-size: 24px;
    }
    .container {
      width: 90%;
    }
    .comment {
      margin-top: 32px;
    }
    .nickName {
      display: inline-block;
      height: 67px;
      color: #3D1101;
      line-height: 67px;
    }
    .avater {
      border-radius: 50%;
    }
    .job {
      float: right;
      margin-top: 1rem;
    }
  }
  #preOrder {
    padding-top: 43px;
    padding-bottom: 50px;
    background: rgba(250,250,250,0.70);
    .container {
      width: 95%;
    }
    .map {
      height: 368px;
      margin-top: 30px;
      background-image: url('../assets/Map.png');
      background-repeat: no-repeat;
    }
    .preOrderForm {
      margin-top: 30px;
      label {
        display: block;
        margin-bottom: 12px;
        color: #3D1101;
        font-size: 14px;
        .input {
          margin-top: 6px;
          width: 100%;
          height: 32px;
          border: 1px solid #CCCCCC;
          box-shadow: inset 0px 1px 0px 0px #ECECEC;
          border-radius: 3px;
          color: #4A4A4A;
          background: #FFFFFF;
        }
      }
      .vegY, .vegN {
        display: inline-block;

      }
      .vegY {
        margin-right: 36px;
      }
      .btnGroup {
        float: right;
        margin-top: 36px;
        button {
          width: 70px;
          height: 36px;
          font-size: 14px;
          border: none;
          border-radius: 3px;
          color: #fff;
        }
        .cancel {
          margin-right: 11px;
          background-color: rgba(0, 0, 0, .35);
        }
        .submit {
          background-color: #F56C23 ;
        }
      }
    }
  }
  @media (min-width: 768px) {
    #features {
      .warp {
        width: 360px;
        margin: 0 auto;
      }
      .hr-t {
        display: inline-block;
      }
      .container {
        width: 95%;
      }
      .feature {
        padding: 0 20px;
      }
    }
    #chef {
      .container {
        width: 95%;
      }
    }
    .comments {
      .container {
        width: 98%;
      }
      .col-9 {
        padding: 0 10px;
      }
    }
    #preOrder {
      .container {
        width: 98%;
      }
      .preOrderForm {
        padding-left: 1rem;
      }
    }
  }
  @media (min-width: 992px) { 
    #features, #chef, .comments, #preOrder {
      .container {
        width: 90%;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/homePage.vue